module.exports = __webpack_public_path__ + "static/media/psm1.d1ba3fa8.png";